import * as React from 'react';

import { useAppSelector } from '../../../app/hooks';

import { useUtilityContext } from '../../../utility-provider';
import { useUserContext } from '../../../user-provider';
import { encryptQueryParam } from '../../../utility/util';
import { userLogging } from '../../../utility/firestore';
import { LOCAL_CONSTANT } from '../../common/Const';
import SelectPlan from '../SelectPlan';

import {
    Button,
    Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { hasScroll } from "../../common/Scroll";


export interface photoIndexProps {
    props:{
    }
}


const PhotoIndex:React.FC<photoIndexProps> = ({props}) => {

    const navigate = useNavigate();
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const receptionBook = useAppSelector((state) => state.receptionBook.select);
    const [disabled, setDisabled] = React.useState<boolean>(false)

    React.useEffect(() => {
        hasScroll();
    }, []);

    // 画面表示 userLogging
    React.useEffect(() => {
        if (user.userData) {
            const currentUrl = window.location.pathname + window.location.search;
            userLogging(
                LOCAL_CONSTANT.FUNCTION_NAME.PHOTO_UPLOAD_INDEX_DISPLAY,
                {url: currentUrl},
                user
            );
        }
    }, []);
    
    React.useEffect(() => {
        setDisabled(true)
        if (receptionBook.plan_area_id !== "") {
            setDisabled(false)
        }
    }, [receptionBook]);


    const clickHandle = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        // URLパラメータ暗号化
        const param = `planAreaId=${receptionBook.plan_area_id}&referrer=`;
        encryptQueryParam(param).then((res) => {
            const url = "/Photo/upload?" + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    const clickBack = () => {
        navigate("/");
    };
    
    return (
        <Box style={{ width: "100%", margin: 0, padding: 0, position: 'relative' }}>
            <Box sx={{margin: '0 10px'}}>
                <Button
                    variant="outlined"
                    size="small"
                    sx={{margin: '4px', minWidth: '30px', padding: '10px 0',
                    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
                    }}
                    onClick={clickBack}
                >≪</Button>
            </Box>
            <Box sx={{margin: '10px'}}>
                <SelectPlan props={{}} />
            </Box>
            <Box sx={{margin: '20px 10px'}}>
                <Button
                    variant="contained" 
                    color="success"
                    disabled={disabled}
                    onClick={clickHandle}
                >アップロード</Button>
            </Box>
        </Box>
    )
}

export default PhotoIndex;